module.exports = __webpack_public_path__ + "static/bg1920-2e1c1f17feabd44f742de8f036dfea9f.jpg";